export enum Roles {
  Engineer = 1,
  Admin = 2,
  Coordinator = 3,
  SuperAdmin = 4,
  ElevatedAdmin = 5,
}
